module.exports = __webpack_public_path__ + "static/media/icons-sprite.26c642e2.svg";